import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getDurationOnePackage } from '../../lib/apis'
import Loader from '../../components/loader'
import CustomButton from '../../components/customButton'
import { toast, ToastContainer } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { scrollToTop } from '../../lib/utils'

function Duree() {
    const { id } = useParams()
    const token = localStorage.getItem("token");
    const packages = useLocation().state
    // eslint-disable-next-line
    const [duration, setDuration] = useState([])
    const [dureeChoise, setDureeChoise] = useState({})
    const [validite, setValidite] = useState([{ package_duration_id: 0 }])
    // const [visibilityProduct, setVisibilityProduct] = useState(false)
    const navigation = useNavigate()
    const [loading, setLoading] = useState(true)
    const { t } = useTranslation()
    const updateDuration = async () => {
        try {
            const { data } = await axios.get(`${getDurationOnePackage}/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
            setDuration(data)

            const status = data.data.map((element: any) => {
                // console.log(element.package_duration_id)
                if (element.package_duration_id === 1) {
                    element.status = true
                } else {
                    element.status = false
                }
                return element
            })
            setValidite(status)
            const value = status.filter((item: any) => item.status === true)
            setDureeChoise(value[0])
            // console.log("value", value)
            // console.log("data", data)
            // console.log(status)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        scrollToTop()
    }, [])

    useEffect(() => {
        updateDuration()
        // eslint-disable-next-line
    }, [])
    const choiseDuree = (id: string) => {
        const tmp = validite.map((elemet: any) => {
            if (elemet.package_duration_id === id) {
                elemet.status = true;
                elemet.nombreProduit = packages.number_of_product
                setDureeChoise(elemet)
            } else {
                elemet.status = false
            }
            return elemet
        })
        setValidite(tmp)
    }
    console.log("dureeChoise", dureeChoise)
    return (
        <div className='w-full  bg-gray-100 p-8  '>
            <div className=" text-3xl flex flex-col justify-center items-center font-semibold mb-6">
                <div>{t("choix_duree")} </div>
                <div style={
                    {
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        padding: "10px",
                        width: "100%",
                        gap: "10px"

                    }
                }>
                    {
                        loading ? <Loader /> :
                            validite.map((item: any, index: number) => {
                                return (
                                    <label style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        fontSize: "17px",
                                        backgroundColor: "white",
                                        borderRadius: "10px",
                                        width: "80%",
                                        padding: "15px",
                                        justifyContent: "space-around",
                                        alignItems: "center"
                                    }} key={index}>
                                        {item.price} Fcfa
                                        <div>{item.number_of_months} {t("mois")}</div>

                                        <input
                                            checked={item.status}
                                            onChange={() => choiseDuree(item.package_duration_id)}
                                            type="checkbox"
                                        />
                                    </label>

                                )
                            })
                    }
                    <div className="flex justify-center w-4/5  py-5">
                        <CustomButton
                            rounded
                            className="bg-primary w-full text-white px-4 py-2"
                            onClick={() => {
                                if (!dureeChoise) {
                                    toast.error("Veuiller choisir une durée")
                                    return
                                }
                                navigation(`/selected_product`, { state: dureeChoise })
                            }}
                        >
                            <span className="text-[20px]">{t("valide_duree")}</span>
                        </CustomButton>
                    </div>
                </div>

            </div>

            <ToastContainer position='top-center' />
        </div>
    )
}

export default Duree